/*
 * BARline Glühgin · bgg-cart.js (MG Commerce, Stand 22.10.2026)
 * Warenkorb-Einschub (Shopify Cart API + Section Rendering), Header ein-/ausblenden, Nach-oben-Button.
 * Gratis-Produkt: liegt es im Warenkorb, obwohl die Schwelle unterschritten ist (Marker data-bgg-gift-autoremove),
 * wird es automatisch entfernt, damit es nie zum vollen Preis berechnet wird.
 * Öffentliche API: window.BGGCart.add(variantId, qty), .open(), .close(), .refresh()
 * Kein jQuery, keine Abhängigkeiten. Wird im Header-Section mit defer geladen.
 */
(function () {
  'use strict';
  if (window.BGGCart) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = function () { return document.getElementById('bgg-cd'); };
  var sectionId = function () {
    var d = drawer();
    var wrap = d && d.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  };
  var lastTrigger = null;
  var busy = false;

  function live(msg) {
    var el = document.querySelector('[data-bgg-cd-live]');
    if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 30); }
  }

  function setCount(n) {
    document.querySelectorAll('[data-bgg-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  }

  function render(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-bgg-cd-content]');
    var cur = d.querySelector('[data-bgg-cd-content]');
    if (fresh && cur) {
      var scroll = cur.querySelector('.bgg-cd__body');
      var top = scroll ? scroll.scrollTop : 0;
      cur.replaceWith(fresh);
      var nb = fresh.querySelector('.bgg-cd__body');
      if (nb) nb.scrollTop = top;
      setCount(fresh.getAttribute('data-count') || 0);
      giftGuard(fresh);
    }
  }

  function giftGuard(scope) {
    var ar = (scope || document).querySelector('[data-bgg-gift-autoremove]');
    if (!ar) return;
    var line = ar.getAttribute('data-bgg-gift-autoremove');
    ar.removeAttribute('data-bgg-gift-autoremove');
    setTimeout(function () { if (!busy) change(line, 0); }, 80);
  }

  function refresh() {
    var sid = sectionId();
    if (!sid) return Promise.resolve();
    return fetch(root + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[sid]); });
  }

  function post(path, body) {
    var sid = sectionId();
    if (sid) body.sections = sid;
    var d = drawer();
    if (d) d.classList.add('is-busy');
    busy = true;
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || 'Fehler'); e.data = data; throw e; }
        return data;
      });
    }).then(function (data) {
      if (sid && data.sections && data.sections[sid]) render(data.sections[sid]);
      else return refresh().then(function () { return data; });
      return data;
    }).finally(function () {
      busy = false;
      var dd = drawer();
      if (dd) dd.classList.remove('is-busy');
    });
  }

  function focusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return x.offsetParent !== null; });
  }

  function open(trigger) {
    var d = drawer();
    if (!d) { window.location.href = root + 'cart'; return; }
    lastTrigger = trigger || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bgg-cart-open');
    document.documentElement.style.overflow = 'hidden';
    var panel = d.querySelector('.bgg-cd__panel');
    setTimeout(function () { var f = d.querySelector('.bgg-cd__close'); (f || panel).focus(); }, 60);
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bgg-cart-open');
    document.documentElement.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function msg(text, state) {
    var el = document.querySelector('[data-bgg-code-msg]');
    if (el) { el.textContent = text || ''; el.setAttribute('data-state', state || ''); }
  }

  function add(variantId, qty, trigger) {
    return post('cart/add.js', { items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
      .then(function () { open(trigger); live('Zum Warenkorb hinzugefügt'); })
      .catch(function (e) { open(trigger); alertInDrawer(e.message); live(e.message); throw e; });
  }

  function alertInDrawer(text) {
    var body = document.querySelector('#bgg-cd .bgg-cd__body');
    if (!body) return;
    var p = document.createElement('p');
    p.className = 'bgg-cd__msg';
    p.setAttribute('data-state', 'error');
    p.setAttribute('role', 'alert');
    p.textContent = text;
    body.prepend(p);
  }

  function change(line, qty) {
    return post('cart/change.js', { line: Number(line), quantity: Math.max(0, Number(qty) || 0) })
      .then(function () { live('Warenkorb aktualisiert'); })
      .catch(function (e) { alertInDrawer(e.message); });
  }

  function currentCodes() {
    var el = document.querySelector('[data-bgg-codes]');
    if (!el) return [];
    return el.getAttribute('data-bgg-codes').split('|').filter(Boolean);
  }

  function applyCode(code) {
    var d = drawer();
    var okText = (d && d.getAttribute('data-ok')) || 'Code eingelöst.';
    var errText = (d && d.getAttribute('data-error')) || 'Dieser Code ist ungültig oder gilt nicht für deinen Warenkorb.';
    code = (code || '').trim();
    if (!code) { msg('Bitte gib einen Code ein.', 'error'); return; }
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    post('cart/update.js', { discount: codes.join(',') }).then(function (data) {
      var found = (data.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      var applied = found ? found.applicable : currentCodes().some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
      if (!applied) {
        // ungültigen Code wieder entfernen, damit er nicht im Warenkorb hängt
        var keep = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
        return post('cart/update.js', { discount: keep.join(',') }).then(function () { msg(errText, 'error'); });
      }
      msg(okText, 'ok');
    }).catch(function () { msg(errText, 'error'); });
  }

  function removeCode(code) {
    var keep = currentCodes().filter(function (c) { return c !== code; });
    post('cart/update.js', { discount: keep.join(',') }).then(function () { msg('', ''); });
  }

  // ------------------------------------------------ Events (Delegation)
  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-bgg-cart-open]');
    if (openBtn && drawer()) { e.preventDefault(); open(openBtn); return; }
    if (t.closest('[data-bgg-cart-close]')) { e.preventDefault(); close(); return; }
    if (t.classList && t.classList.contains('bgg-cd') && t.classList.contains('is-open')) { close(); return; }
    var q = t.closest('[data-bgg-line][data-bgg-qty]');
    if (q && !busy) { e.preventDefault(); change(q.getAttribute('data-bgg-line'), q.getAttribute('data-bgg-qty')); return; }
    var a = t.closest('[data-bgg-add]');
    if (a && !busy) { e.preventDefault(); add(a.getAttribute('data-bgg-add'), a.getAttribute('data-bgg-add-qty'), a).catch(function () {}); return; }
    var rc = t.closest('[data-bgg-code-remove]');
    if (rc && !busy) { e.preventDefault(); removeCode(rc.getAttribute('data-bgg-code-remove')); return; }
    if (t.closest('[data-bgg-totop]')) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-bgg-line-input]');
    if (inp && !busy) change(inp.getAttribute('data-bgg-line-input'), inp.value);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bgg-code-form]');
    if (f) { e.preventDefault(); var i = f.querySelector('[data-bgg-code-input]'); applyCode(i ? i.value : ''); }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(d.querySelector('.bgg-cd__panel'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ------------------------------------------------ Header (Headroom) + Nach-oben-Button
  function initScroll() {
    var hdr = document.querySelector('[data-bgg-header]');
    var wrap = hdr && hdr.closest('.shopify-section');
    var mode = hdr ? hdr.getAttribute('data-sticky') : 'none';
    var totop = document.querySelector('[data-bgg-totop]');
    var last = window.scrollY, ticking = false;
    // Höhe aller Sections vor dem Header (z. B. Topbar) = Punkt, ab dem der Header klebt
    function baseOffset() {
      var b = 0, p = wrap ? wrap.previousElementSibling : null;
      while (p) { if (p.classList && p.classList.contains('shopify-section')) b += p.offsetHeight; p = p.previousElementSibling; }
      return b;
    }
    var base = baseOffset();
    window.addEventListener('resize', function () { base = baseOffset(); });
    function update() {
      var y = window.scrollY, d = y - last;
      if (wrap && mode !== 'none') {
        var start = base + wrap.offsetHeight;
        wrap.classList.toggle('is-stuck', y > base);
        if (mode === 'headroom') {
          if (y <= start || document.body.classList.contains('bgg-cart-open')) wrap.classList.remove('is-hidden');
          else if (d > 6) wrap.classList.add('is-hidden');
          else if (d < -6) wrap.classList.remove('is-hidden');
        }
      }
      if (totop) totop.classList.toggle('is-visible', y > 700);
      if (Math.abs(d) > 6) last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    if (wrap) wrap.addEventListener('focusin', function () { wrap.classList.remove('is-hidden'); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initScroll); else initScroll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { giftGuard(document); }); else giftGuard(document);

  // Videos mit data-bgg-autoplay erst abspielen, wenn sichtbar (spart Daten, schneller Seitenaufbau)
  function initAutoplay() {
    // Ton-Buttons für native Videos (data-bgg-sound → zugehöriges video)
    var vids = document.querySelectorAll('video[data-bgg-autoplay]');
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { if (!reduce) { v.preload = 'auto'; v.play().catch(function () {}); } }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reduce) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
        else if (!en.isIntersecting) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { if (v.__bggObs) return; v.__bggObs = true; io.observe(v); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAutoplay); else initAutoplay();
  document.addEventListener('shopify:section:load', initAutoplay);

  window.BGGCart = { add: add, open: open, close: close, refresh: refresh, change: change };
  window.BGGMedia = { initAutoplay: initAutoplay };
})();
